import Axios from "axios";
import config from "../app.config";

export var adminManagementService;
export default adminManagementService = {
    getAdmins,
    getAdmin,
    updateAdmin,
    createAdmin,
    deleteAdmins,
    resetPassword,
    // getListAdminSelect
}

async function getAdmins(payload){
    return await Axios.get(`${config.LOCAL_API_URL}/admin`,{params: payload})
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error);
    })
}
async function getAdmin(id){
    return await Axios.get(`${config.LOCAL_API_URL}/admin/` + id)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
async function updateAdmin(data){
    return await Axios.put(`${config.LOCAL_API_URL}/admin/` + data.id, data)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
async function deleteAdmins(params){
    return await Axios.delete(`${config.LOCAL_API_URL}/admin`, {data: params})
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
async function createAdmin(params){
    return await Axios.post(`${config.LOCAL_API_URL}/admin`, params)
    .then(response => {
        if(response.data.success || response.data.status) return Promise.resolve(response.data)
        else return Promise.reject(response.data)
    })
    .catch(error =>{
        return Promise.reject(error.response.data);
    })
}
async function resetPassword(ids){
    return await Axios.post(`${config.LOCAL_API_URL}/ajax/setting-admin/resetpass`, ids)
        .then(response => {
            if(response.data.success || response.data.status) return Promise.resolve(response.data)
            else return Promise.reject(response.data)
        })
        .catch(error =>{
            return Promise.reject(error.response.data);
        })
}
// async function getListUserSelect(data) {
//     return await Axios.get(`${config.LOCAL_API_URL}/getListUserSelect`)
//         .then(
//             response => {
//                 if(response.data) {
//                     return Promise.resolve(response.data);
//                 } else {
//                     return Promise.reject(response);
//                 }
//             }).catch(error =>{
//             return Promise.reject(error);
//         })
// }